import { fmtDate } from "@/lib/utils";
import { useEffect, useState } from "react";
import api, { API } from "@/lib/api";
import { Wallet, FileDown, Clock, CheckCircle2 } from "lucide-react";

const STATUS = { offen: "bg-amber-500/15 text-amber-400", ausgezahlt: "bg-emerald-500/15 text-emerald-400", storniert: "bg-red-500/15 text-red-400" };

export const PartnerPayouts = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/partner/payouts").then((r) => setData(r.data)).catch(() => setData({ payouts: [], offen: 0, ausgezahlt: 0, gesamt: 0 })); }, []);
  if (!data) return <p className="text-slate-400">Lädt…</p>;
  return (
    <div data-testid="partner-payouts">
      <div className="grid sm:grid-cols-3 gap-4 mb-5">
        {[["Offen", data.offen, Clock, "text-amber-400"], ["Ausgezahlt", data.ausgezahlt, CheckCircle2, "text-emerald-400"], ["Gesamt", data.gesamt, Wallet, "text-[#FF5A1F]"]].map(([l, v, Icon, c]) => (
          <div key={l} className="eb-card p-5" data-testid={`payout-sum-${l.toLowerCase()}`}>
            <div className="flex items-center justify-between mb-2"><span className="eb-label">{l}</span><Icon className={`w-4 h-4 ${c}`} /></div>
            <div className={`font-head text-2xl font-bold ${c}`}>{v} €</div>
          </div>
        ))}
      </div>
      <div className="eb-card overflow-hidden">
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-800">
          <span className="text-sm text-slate-400">{data.anzahl} Auszahlungsposten</span>
          <a href={`${API}/partner/payouts/pdf`} target="_blank" rel="noreferrer" className="eb-btn-outline !py-1.5 text-sm" data-testid="payout-pdf-btn"><FileDown className="w-4 h-4" /> Auszahlungs-PDF</a>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="border-b border-slate-800 text-left">{["Datum", "Buchung", "Route", "Partnerpreis", "Gebühr", "Auszahlung", "Status"].map((h) => <th key={h} className="px-4 py-2.5 eb-label">{h}</th>)}</tr></thead>
            <tbody>
              {data.payouts.length === 0 ? <tr><td colSpan={7} className="px-4 py-8 text-center text-slate-500">Noch keine Auszahlungen.</td></tr> : data.payouts.map((p) => (
                <tr key={p.id} className="border-b border-slate-800/50" data-testid={`payout-row-${p.id}`}>
                  <td className="px-4 py-2.5 text-slate-300">{fmtDate(p.created_at)}</td>
                  <td className="px-4 py-2.5 mono text-slate-400">{p.booking_short}</td>
                  <td className="px-4 py-2.5 text-slate-300">{p.route_label}</td>
                  <td className="px-4 py-2.5 mono">{p.partnerpreis} €</td>
                  <td className="px-4 py-2.5 mono text-slate-400">-{p.zahlungsgebuehr} €</td>
                  <td className="px-4 py-2.5 mono text-emerald-400 font-semibold">{p.auszahlungsbetrag} €</td>
                  <td className="px-4 py-2.5"><span className={`eb-badge ${STATUS[p.status] || "bg-slate-700 text-slate-300"}`}>{p.status}</span>{p.credit_note_number && <a href={`${API}/payouts/${p.id}/credit-note`} target="_blank" rel="noreferrer" className="ml-2 text-xs text-[#FF5A1F] underline" data-testid={`partner-credit-note-${p.id}`}>{p.credit_note_number}</a>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
